/* global Swiper */
document.querySelectorAll( '.b-game-carousel' ).forEach( ( block ) => {

	if ( typeof window.Swiper !== 'function' ) {

		return;

	}

	/**
	 * Tell whether the visitor asked for as little motion as the interface can get away with.
	 *
	 * @return {boolean} True when the reduced-motion preference is set.
	 */
	const prefersReducedMotion = () => window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	/**
	 * Bring a tile reached with the keyboard into view without taking the section with it.
	 *
	 * @param {Object}      swiper The slider built on it.
	 *
	 * @return {void}
	 */
	const keepFocusedTileInView = ( swiper ) => {

		block.addEventListener( 'focusin', ( event ) => {

			const tile = event.target.closest( '.c-scratch-game-card' );

			if ( ! tile ) {

				return;

			}

			block.scrollLeft = 0;

			const slide = tile.closest( '.swiper-slide' );
			const index = swiper.slides.indexOf( slide );

			if ( index > -1 && ! swiper.visibleSlides.includes( slide ) ) {

				swiper.slideTo( index );

			}

		} );

	};

	/**
	 * Initialise a single slider instance.
	 *
	 * @return {void}
	 */
	const initSlider = () => {

		const slider = block.querySelector( '.b-game-carousel__slider' );

		if ( ! slider || slider.dataset.swiperReady === 'true' ) {

			return;

		}

		const prevEl = block.querySelector( '.b-game-carousel__nav-button--prev' );
		const nextEl = block.querySelector( '.b-game-carousel__nav-button--next' );
		const scrollbarEl = block.querySelector( '.b-game-carousel__progress' );

		const swiper = new Swiper( slider, {
			slidesPerView: 'auto',
			spaceBetween: 20,
			watchSlidesProgress: true,
			speed: prefersReducedMotion() ? 0 : 400,
			watchOverflow: true,
			allowTouchMove: true,
			simulateTouch: true,
			mousewheel: {
				enabled: true,
				forceToAxis: true,
				releaseOnEdges: true,
			},
			grabCursor: true,
			threshold: 8,
			a11y: {
				enabled: true,
				prevSlideMessage: prevEl?.getAttribute( 'aria-label' ),
				nextSlideMessage: nextEl?.getAttribute( 'aria-label' ),
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			navigation: ( prevEl && nextEl ) ? { prevEl, nextEl } : false,
			scrollbar: scrollbarEl ? { el: scrollbarEl, draggable: true } : false,
			breakpoints: {
				768: {
					spaceBetween: 24,
				},
			},
		} );

		keepFocusedTileInView( swiper );

		slider.dataset.swiperReady = 'true';

	};

	initSlider();

} );
